import { useEffect, useState } from "react";
import axios from 'axios';

const Test2 = () => {
  const [formData, setFormData] = useState({
    cardNo: "",
    expMonth: "",
    expYear: "",
    idNo: "",
    cardPw: "",
    // cardNo: "5181850045162037",
    // expMonth: "02",
    // expYear: "30",
    // idNo: "970308",
    // cardPw: "27",
  });

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://pay.nicepay.co.kr/v1/js/";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  // input 값 변경 처리
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // 서버로 form 제출
  const handleSubmit = async (e) => {
    e.preventDefault(); // 기본 폼 제출 막기
    try {
        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/nicepay/regular`,formData);
        if(response.status==200){
            alert('정기결제가 완료되었습니다.');
            window.location.reload();
        }
    } catch (err) {
      console.error("서버 제출 오류:", err);
      alert("서버 제출 실패");
    }
  };

  return (
    <div className="rootContainer">
      <h1>결제 테스트중입니다.</h1>
      <form onSubmit={handleSubmit}>
        <label>Card number</label><br />
        <input type="text" name="cardNo" value={formData.cardNo} onChange={handleChange} /><br /><br />

        <label>Expiry month (MM)</label><br />
        <input type="text" name="expMonth" value={formData.expMonth} onChange={handleChange} /><br /><br />

        <label>Expiry year (YY)</label><br />
        <input type="text" name="expYear" value={formData.expYear} onChange={handleChange} /><br /><br />

        <label>생년월일 / 사업자번호</label><br />
        <input type="text" name="idNo" value={formData.idNo} onChange={handleChange} /><br /><br />

        <label>Card password 2 digit</label><br />
        <input type="text" name="cardPw" value={formData.cardPw} onChange={handleChange} /><br /><br />

        <button type="submit">서버로 전송</button>
      </form>
    </div>
  );
};

export default Test2;
